module.exports = __webpack_public_path__ + "static/media/rec.ac8d2e12.png";